// path: frontend/src/components/Footer.tsx
import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  // ── Affiliate / Ads placeholder ──
  // Set VITE_ADS_ENABLED=true in .env to enable
  const ADS_ENABLED = import.meta.env.VITE_ADS_ENABLED === "true";

  return (
    <footer className="mt-auto border-t border-black/5 dark:border-white/10 bg-white/50 dark:bg-slate-900/50 backdrop-blur-sm">
      <div className="max-w-6xl mx-auto px-4 py-8">

        {/* Affiliate / Ads Section — disabled by default */}
        {ADS_ENABLED && (
          <div className="mb-6 p-4 rounded-lg bg-gray-50 dark:bg-gray-800/30 border border-gray-200 dark:border-gray-700">
            <p className="text-xs text-gray-500 dark:text-gray-400 text-center mb-3">Recommended Resources</p>
            {/* Add affiliate/ad components here when ready */}
          </div>
        )}

        {/* Links Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          {/* About */}
          <div>
            <h3 className="font-semibold text-sm mb-3 text-gray-900 dark:text-gray-100">AutoQuiz AI</h3>
            <p className="text-xs text-gray-600 dark:text-gray-400 leading-relaxed">
              Create AI-powered quizzes, interactive flashcards, and quiz videos for studying, teaching, and content creation.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-sm mb-3 text-gray-900 dark:text-gray-100">Quick Links</h3>
            <ul className="space-y-2 text-xs">
              <li><Link to="/" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Home</Link></li>
              <li><Link to="/flashcards" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Flashcards</Link></li>
              <li><Link to="/history" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">My Videos</Link></li>
              <li><Link to="/credits" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Credits</Link></li>
              <li><Link to="/faq" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">FAQ</Link></li>
              <li><Link to="/privacy" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Terms of Service</Link></li>
              <li><Link to="/refund-policy" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Refund & Credit Policy</Link></li>
              <li><a href="mailto:services@findtheideas.com" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Support</a></li>
            </ul>
          </div>

          {/* Our Projects & Books */}
          <div>
            <h3 className="font-semibold text-sm mb-3 text-gray-900 dark:text-gray-100">Our Projects & Books</h3>
            <ul className="space-y-2 text-xs">
              <li>
                <a
                  href="https://findtheideas.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                >
                  FindTheIdeas
                </a>
              </li>
              <li>
                <a
                  href="https://locuvo.findtheideas.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                >
                  Locuvo
                </a>
              </li>
              <li className="pt-1 text-gray-500 dark:text-gray-500">My Books on Amazon</li>
              <li>
                <a
                  href="https://www.amazon.com/dp/B0H3GXNLJX"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                >
                  Revenue Cycle Management in Medical Billing
                </a>
              </li>
              <li>
                <a
                  href="https://www.amazon.com/dp/B0HF42QPDK"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                >
                  Certified Billing and Coding Specialist Exam Study Guide 2026–2027
                </a>
              </li>
              <li>
                <a
                  href="https://www.amazon.com/dp/B0HF3VDYKC"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                >
                  Certified Billing and Coding Specialist Practice Tests 2026–2027
                </a>
              </li>
              <li>
                <a
                  href="https://www.amazon.com/dp/B0HHK2KRY2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                >
                  Medical Terminology for Allied Health Sciences
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-black/5 dark:border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
            <p>© {currentYear} MC SANTE PLUS SERVICES LLC · AutoQuiz AI</p>
            <p className="text-center text-xs text-gray-400 dark:text-gray-500 max-w-xl">
              AI-generated content may contain errors. Review quiz content before publishing or relying on it.
            </p>
          </div>
        </div>

      </div>
    </footer>
  );
}
